import {Container, Col, Row }from 'react-bootstrap';

import Header from '../sections/header';
import Footer from '../sections/footer';
import MainContent from '../sections/maincontent';
import TitleBlock from '../gridspaces/titleblock';
import SplashImage from '../gridspaces/splashimage';
import CountDownBox from '../blocks/Countdown';


function PageHome(){
    return (
        <> 
            <Header />
            <Container fluid className="color-bg-secondary">
                    <MainContent>
                        <Row>
                            <SplashImage image="https://cdn.bigdistanceenergy.com/bde/s/assets/images/about-splash.jpg" />
                        </Row>
                        <Row>
                           

                            <TitleBlock 
                                title='art' 
                                subtitle='An Independent Crafts Studio' 
                                text='Big Distance Energy is an independent crafts studio that uses various skills in digital and print media as well as textiles to create marketing strategies and consumer experiences that tell stories. Our partners work collaboratively or independently to craft unique works that provoke thought and emotion.

Big Distance Energy was founded during 2024, in Dallas, Texas. The studio was designed to be a vehicle within the confines of endurance sport to polish and present remarkable people, events, and organizations whose work would go unnoticed because there was not a more enticing presentation to shepherd it into more mainstreams.' />
                            <TitleBlock 
                                title='mission' 
                                subtitle='Our Mission' 
                                text='At Big Distance Energy, we aim to engage the imagination and solicit buy-in from fans and participants of sub-elite athletics through effective communication. We consider ourselves crafters and curators of stories that communicate the “joys and journeys” as well as the "highs and lows" of distance sport at non-professional levels. With stories that build community through creative and technical media, our aim is to market, brand, and promote underdog stories—using multiple disciplines to package a concise and coherent brand message. Messages use digital media, print media, and textiles to weave stories of perseverance and triumph together. Delivering stories of weekend warriors and athletes who work tirelessly to become great (while working day jobs) is what we excel in.' />
                            
                            <TitleBlock 
                                title='vision' 
                                subtitle='Our Vision' 
                                text='At Big Distance Energy, we aim to influence storytelling and create stories that ordinary people can easily relate to by becoming the go-to studio for telling the underdog stories of amateur distance athletes—whether it’s motivation, a dream, goals, or anything that can encourage someone to keep putting one foot in front of the other until they go the distance. Until they go all the way. These are stories that help you visualize where you want to be—stories that embody going the distance.' />
    
                        </Row>
                        <Row>
                        <Col md={{span: 4}}>
                            <TitleBlock 
                                title='events' 
                                subtitle='Upcoming Events' 
                                text='Times for upcoming events.' />
                        </Col>
                        <Col md={{span: 8}}>
                            <CountDownBox title="We Mambo: Mi Cocina 5k" isoDatatime="2026-08-08T12:00:00.000Z"/>
                            <CountDownBox title="Sydney Marathon" isoDatatime="2026-08-29T21:20:00.000Z"/>
                            <CountDownBox title="Berlin Marathon" isoDatatime="2026-09-27T05:20:00.000Z"/>
                            <CountDownBox title="California International Marathon" isoDatatime="2026-12-06T14:20:00.000Z"/>
                        </Col>
                        </Row>
                    <Row>
                        <Col>
                            <a href="/services" className="font-body color-font-primary font-size-large text-start url-style">Services</a>
                        </Col>
                        <Col>
                            <a href="/audience" className="font-body color-font-primary font-size-large text-start url-style">Who we help</a>
                        </Col>
                    
                    </Row>
                </MainContent>
            </Container>
            <Footer />
        </>
    )
}

export default PageHome;